// Household Purifier Products Data
    export const householdPurifierProducts = {
      'household-purifier-series': {
        id: 'household-purifier-series',
        title: 'Household Purifier Series',
        name: 'Household Purifier Series',
        category: 'Household Purifier',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/260df89bb0bed8510355393a7c38b57b.png',
        shortDescription: 'A comprehensive range of household water purifiers, including countertop and under-sink models with various filtration technologies.',
        description: 'Our Household Purifier Series offers a variety of solutions to meet your home water filtration needs, from simple countertop units to advanced multi-stage RO systems.',
        longDescription: 'The Household Purifier Series includes a wide selection of water treatment systems designed for residential use. This series features countertop models (HP-A1, HP-A2, HP-A3), stainless steel units (SP-10A1, SP-10A2, SP-10A3, SP-10B2, SP-10B3), and advanced purification systems like Reverse Osmosis (HP-RO) and Ultrafiltration (HP-UF). Whether you need basic sediment and chlorine removal or high-purity drinking water, our household purifiers provide reliable performance, easy installation, and convenient maintenance.',
        features: [
          'Multiple filtration stages for comprehensive purification',
          'Available with various technologies: PP sediment, activated carbon, UF, and RO',
          'Countertop and under-sink models to fit different kitchen layouts',
          'Durable construction with options for plastic or stainless steel housings',
          'Easy to install and maintain with user-friendly filter cartridge replacement',
          'Provides safe, clean, and great-tasting water directly from your tap'
        ],
        applications: [
          'Drinking water purification',
          'Cooking and food preparation',
          'Improving taste and odor of tap water',
          'Removing chlorine, sediment, and other contaminants',
          'Residential kitchens and small offices'
        ],
        specifications: {
          'Filtration Technologies': 'Sediment (PP), Granular Activated Carbon (GAC), Carbon Block (CTO), Ultrafiltration (UF), Reverse Osmosis (RO)',
          'Housing Materials': 'Food-grade Plastic, Stainless Steel (SS304)',
          'Installation Type': 'Countertop, Under-sink',
          'Configurations': '1-stage, 2-stage, 3-stage, and multi-stage RO systems',
        },
        technicalData: {
          'Available Models': [
            { model: 'HP-A1', type: '1-Stage Countertop Purifier', housing: 'Plastic' },
            { model: 'HP-A2', type: '2-Stage Countertop Purifier', housing: 'Plastic' },
            { model: 'HP-A3', type: '3-Stage Countertop Purifier', housing: 'Plastic' },
            { model: 'HP-RO', type: 'Multi-Stage Under-Sink RO System', housing: 'Plastic with Steel Frame' },
            { model: 'HP-UF', type: '3-Stage Under-Sink UF System', housing: 'Plastic with Steel Frame' },
            { model: 'SP-10A1', type: '1-Stage Countertop Purifier', housing: 'Stainless Steel' },
            { model: 'SP-10A2', type: '2-Stage Countertop Purifier', housing: 'Stainless Steel' },
            { model: 'SP-10A3', type: '3-Stage Countertop Purifier', housing: 'Stainless Steel' },
            { model: 'SP-10B2', type: '2-Stage Under-Sink Purifier with Gauge', housing: 'Stainless Steel' },
            { model: 'SP-10B3', type: '3-Stage Under-Sink Purifier with Gauge', housing: 'Stainless Steel' }
          ]
        }
      }
    };

    export const householdPurifierProductsList = [
      {
        id: 'household-purifier-series',
        name: 'Household Purifier Series',
        category: 'Household Purifier',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/260df89bb0bed8510355393a7c38b57b.png',
        shortDescription: 'A comprehensive range of household water purifiers, including countertop and under-sink models.',
        description: 'A range of household water purifiers including countertop and under-sink models with various filtration technologies like UF and RO.',
        features: [
          'Countertop and under-sink models',
          'Various filtration technologies (UF, RO, Carbon)',
          'Plastic and stainless steel housing options'
        ],
        applications: [
          'Drinking water purification',
          'Kitchen and residential use',
          'Small offices'
        ]
      }
    ];

    export default householdPurifierProducts;